<template>
  <Pie :chart-data="chartData" :chart-options="chartOptions" ref="piechart" />
</template>
<script>
import { mapGetters } from 'vuex';
import { Pie } from 'vue-chartjs/legacy';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

export default {
  name: 'PieChart',
  components: { Pie },
  props: {
    labels: {
      type: Array,
      required: true,
      default: () => [],
    },
    datasets: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chartData: {
        labels: this.labels,
        datasets: this.datasets,
      },
    };
  },
  computed: {
    ...mapGetters(['getDarkmode']),
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          bar: {
            borderWidth: 2,
          },
        },
        onClick: (e) => {
          const chart = this.$refs.piechart.getCurrentChart();
          const activePoints = chart.getElementsAtEventForMode(e, 'point', {});
          const label = chart.data.labels[activePoints[0].index];
          const value = chart.data.datasets[activePoints[0].datasetIndex].data[
            activePoints[0].index
          ];

          this.$emit('click', { label, value });
        },
        plugins: {
          title: {
            display: true,
            text: this.title,
            color: this.getDarkmode ? '#56a3e0' : '#424c55',
          },
          legend: {
            display: true,
            labels: {
              color: this.getDarkmode ? '#99afbc' : '#424c55',
            },
          },
        },
      };
    },
  },
  watch: {
    getDarkmode() {
      this.$refs.piechart.renderChart(this.chartData, this.chartOptions);
    },
  },
};
</script>
